export default __webpack_public_path__ + "static/media/Vector (2).332a6936.svg";